import React from 'react';
import { Box, Container, Divider, Typography } from '@mui/material';
import ReleaseScaffolding from './releaseScaffold';

const releaseSections = [
  { id: 'beta-7-5', title: 'Blitz 7.5 – Dragon Egg Release (June 12 2025)' },
  { id: 'beta-7',   title: 'Blitz 7.0 – Golden Goose Release (April 16 2025)' },
  { id: 'beta-6',   title: 'Blitz 6.0 – Iron Dragon Release (March 23 2025)' },
  { id: 'beta-5',   title: 'Blitz 5.0 – Blitz Lizard Release (February 5 2025)' },
  { id: 'beta-4',   title: 'Blitz 4.0 – Platform Foundation Release' },
  { id: 'beta-3',   title: 'Blitz 3.0 – MVP Launch Release' },
];

export default function BlitzReleaseNotes() {
  return (
    <ReleaseScaffolding sections={releaseSections}>
      <Container>
        {releaseSections.map(section => (
          <Box key={section.id} id={section.id} sx={{ mb: 4 }}>
            <Typography variant="h4">{section.title}</Typography>
            <Divider />

            {section.id === 'beta-7-5' && (
              <>
                <Typography variant="h6" sx={{ mt: 2 }}>New Features</Typography>
                <ul>
                  <li><strong>iOS Launch:</strong> Capacitor build live on the App Store.</li>
                  <li><strong>Chat 3.0:</strong> unified component, conversation names, last-online, attachment browser, join-via-link, community vs deal channels.</li>
                  <li><strong>Bio / CRM Upgrades:</strong> link-in-bio 2.0, richer profile fields, creator analytics export.</li>
                  <li><strong>Amplified AM/Seller System:</strong> Octopus affiliate dashboards, commission tracking, in-chat money requests and tipping.</li>
                  <li><strong>Brand-Side UX:</strong> campaign notes and feedback columns on creator rows.</li>
                </ul>
                <Typography variant="h6">Improvements</Typography>
                <ul>
                  <li>Email automations for asset submission and review.</li>
                  <li>Mobile-responsive fix for “Add Creators”, global backups on every deploy, finance feeds piped into Sheets.</li>
                </ul>
                <Typography variant="h6">Bug Fixes</Typography>
                <ul>
                  <li>Duplicate campaign-folder guard.</li>
                  <li>Blocked spam from external payment-service emails.</li>
                  <li>General UI/UX polish across chat, media kits, and campaign pages.</li>
                </ul>
              </>
            )}

            {section.id === 'beta-7' && (
              <>
                <Typography variant="h6" sx={{ mt: 2 }}>New Features</Typography>
                <ul>
                  <li><strong>Chat 2.0:</strong> single code base, community channels, attachment vault.</li>
                  <li><strong>Global User Standard:</strong> single account for brands and creators, multi-auth, admin approval.</li>
                  <li><strong>Link-in-Bio v1:</strong> editable media-kit pages with ad slots and marketplace hooks.</li>
                  <li><strong>Sales Stack:</strong> Octopus brand affiliate engine and TRM roster management.</li>
                  <li><strong>Revenue Lines:</strong> subscriptions, white-label instances, self-service checkout, BlitzPay pipeline.</li>
                  <li><strong>Partial Invoicing & Money Requests:</strong> chat-based payment links and tips tool.</li>
                  <li><strong>Sharable Reporting:</strong> Spotify-wrapped-style summaries and live multi-video tracking.</li>
                  <li><strong>System Notifications 2.0:</strong> cron-driven unread badges for messages, status, new users, and more.</li>
                  <li><strong>Contract Management:</strong> sign, edit, and share contracts inside chat with audit metadata.</li>
                  <li><strong>View My Team:</strong> seat list, inactive users, approval queue, email prefs.</li>
                  <li><strong>Creator Ranking & Username Search:</strong> marketplace transparency and direct filters.</li>
                  <li><strong>Partner / Supervisor Flow:</strong> supervisor assignment, bonus payouts, full fee breakdown.</li>
                  <li><strong>Spending Power & Balance Loader:</strong> instant top-ups and streamlined requests.</li>
                </ul>
                <Typography variant="h6">Improvements</Typography>
                <ul>
                  <li>Slimmed creator campaign page, Azure-hosted AI sourcing, new follow-ups algorithm.</li>
                  <li>Global responsive cleanup, strengthened email/phone verification, upgraded partner system.</li>
                </ul>
                <Typography variant="h6">Bug Fixes</Typography>
                <ul>
                  <li>Email queue edge cases and navbar unread mis-counts fixed.</li>
                  <li>Patched creator-card flex-wrap on small screens and duplicate folder issues.</li>
                </ul>
              </>
            )}

            {section.id === 'beta-6' && (
              <>
                <Typography variant="h6" sx={{ mt: 2 }}>New Features</Typography>
                <ul>
                  <li><strong>First iOS TestFlight build.</strong></li>
                  <li><strong>BlitzPay Acceleration:</strong> net-30 workflow, balance and spending power UI.</li>
                  <li><strong>Partnerships v2 & Complex Campaign Engine:</strong> multi-video, cross-posting, CPM rates, agency negotiation.</li>
                  <li><strong>Conversation Upgrades:</strong> user adds, auto-share, Creator Chat Hub, live timelines.</li>
                  <li><strong>Invoice Enrichment:</strong> billed-to, issue/due dates, itemized rows, banking info.</li>
                  <li><strong>Age Verification:</strong> birthday capture to replace niche flags.</li>
                  <li><strong>Rate Calculator & Market Rates.</strong></li>
                  <li><strong>AI-Driven Email follow-ups & CRM integration.</strong></li>
                  <li><strong>Catalogs Page:</strong> public collections and curated campaigns.</li>
                  <li><strong>Azure sourcing pipeline.</strong></li>
                </ul>
                <Typography variant="h6">Improvements</Typography>
                <ul>
                  <li>Promotion-type support for YouTube, Twitch, Kick CPM.</li>
                  <li>End-to-end App Store Connect docs in onboarding.</li>
                </ul>
                <Typography variant="h6">Bug Fixes</Typography>
                <ul>
                  <li>Creator drop/resend-offer edge cases fixed.</li>
                  <li>Collab-booking sync glitches resolved.</li>
                  <li>Marketplace and invoice consistency improvements.</li>
                </ul>
              </>
            )}

            {section.id === 'beta-5' && (
              <>
                <Typography variant="h6" sx={{ mt: 2 }}>New Features</Typography>
                <ul>
                  <li><strong>Functional & Financials</strong>
                    <ul>
                      <li>Rewrite balance logic for seamless operations.</li>
                      <li>New Withdrawal entity and auto-generated records.</li>
                      <li>Manual payouts with automatic withdrawal creation.</li>
                      <li>Agency invoice approval auto-creates withdrawal.</li>
                    </ul>
                  </li>
                  <li><strong>User Functions & Settings Overhaul</strong>
                    <ul>
                      <li>Customizable user preferences (colors, emails, feature tabs).</li>
                      <li>User settings table interacts with tokens for themes.</li>
                      <li>Enhanced search algorithm with aggregated collections.</li>
                    </ul>
                  </li>
                  <li><strong>Bigger Agency Pages</strong></li>
                  <li><strong>Email-to-Conversation Webhook and Templates</strong></li>
                  <li><strong>Campaign Param Security Update</strong></li>
                  <li><strong>CRM Updates & Cleaning</strong></li>
                  <li><strong>Agency Creator Connect</strong>
                    <ul>
                      <li>Restricted deal visibility and disabled pitching.</li>
                    </ul>
                  </li>
                  <li><strong>Data Exports</strong></li>
                  <li><strong>Campaign Workflow Enhancements</strong></li>
                  <li><strong>Single Sign-On & Acquisition Tech</strong></li>
                  <li><strong>Media Kit Link Enhancements</strong></li>
                  <li><strong>Sender Email Selection</strong></li>
                  <li><strong>Password Reset Flow</strong></li>
                  <li><strong>Contract Management</strong></li>
                  <li><strong>User Conversations Hub, Onboarding Refresh, Referral Incentives, Marketplace Redesign, Homepage Refresh, AI-Powered Campaign Creation, Banking Integrations, Advanced Data Exports</strong></li>
                </ul>
                <Typography variant="h6">Improvements</Typography>
                <ul>
                  <li>Streamlined balances and CRM re-engagement.</li>
                  <li>Modernized styling and partial Agency Creator Connect views.</li>
                  <li>Homepage refresh, onboarding redirects, incentive sharing.</li>
                  <li>Marketplace one-creator vs multi-creator flow, improved media-kit links.</li>
                </ul>
                <Typography variant="h6">Bug Fixes</Typography>
                <ul>
                  <li>Duplicate “@” symbol on YouTube handles removed.</li>
                  <li>UI inconsistencies in partnership interface resolved.</li>
                  <li>Styling issues in conversations and onboarding fixed.</li>
                </ul>
              </>
            )}

            {section.id === 'beta-4' && (
              <>
                <Typography variant="h6" sx={{ mt: 2 }}>New Features</Typography>
                <ul>
                  <li>AI Search Alpha for creator discovery.</li>
                  <li>Creator Connect UX redesign.</li>
                  <li>Financial modules for Money and Collabs pages.</li>
                  <li>Deal factoring and milestone tracking.</li>
                  <li>Scheduled deliverables with calendar integration.</li>
                  <li>BlitzPay 2.0 shared payment schedules.</li>
                  <li>Marketplace refresh with recommendation algorithm.</li>
                  <li>Auth unification and tiered fee structure.</li>
                  <li>Single-page onboarding.</li>
                </ul>
                <Typography variant="h6">Improvements</Typography>
                <ul>
                  <li>Platform cleanup of inactive creators.</li>
                  <li>Scalable documentation and simplified signup flows.</li>
                  <li>User growth milestones achieved.</li>
                </ul>
                <Typography variant="h6">Bug Fixes</Typography>
                <ul>
                  <li>Payment schedule sync issues resolved.</li>
                  <li>Marketplace card rendering fixes.</li>
                </ul>
              </>
            )}

            {section.id === 'beta-3' && (
              <>
                <Typography variant="h6" sx={{ mt: 2 }}>New Features</Typography>
                <ul>
                  <li>Paid campaign tiers with AI facilitation.</li>
                  <li>CSV talent-roster import tool.</li>
                  <li>Fan engagement system with tipping.</li>
                  <li>Hot Creator weekly algorithm.</li>
                  <li>Advanced reach/demographic filters.</li>
                  <li>Multi-currency support.</li>
                  <li>Email-driven Alito Campaign Manager.</li>
                  <li>Creator pitching via Apollo API.</li>
                  <li>Subscription tiers with financing terms.</li>
                  <li>Media booking system and CRM automation.</li>
                </ul>
                <Typography variant="h6">Improvements</Typography>
                <ul>
                  <li>Search page overhaul and recommended creators.</li>
                  <li>Campaign management upgrades and creator portal.</li>
                  <li>Payment infrastructure and CRM triggers.</li>
                  <li>Tax compliance basics and partner integrations.</li>
                </ul>
                <Typography variant="h6">Bug Fixes</Typography>
                <ul>
                  <li>CSV campaign-duplication issues fixed.</li>
                  <li>Currency conversion discrepancies resolved.</li>
                  <li>SMS routing errors patched.</li>
                </ul>
              </>
            )}
          </Box>
        ))}
      </Container>
    </ReleaseScaffolding>
  );
}
